import axios from 'axios';

export class RealEstateListing {
    constructor() {
        this.http = axios.create({
            baseURL: process.env.VUE_APP_REAL_ESTATE_LISTING_URL,
        });
    }

    async getGatewayProcessStat(processId) {
        try {
            const { data } = await this.http.get(`/stat/source/process/${processId}`);
            return data;
        } catch {
            return null;
        }
    }
}
